<template>
	<a-modal
		title="Enviar Presupuesto por email"
		centered
		:visible="visible"
		:mask-closable="false"
		:width="800"
		:body-style="{ padding: '15px' }"
		:ok-button-props="{ props: { disabled: !valid } }"
		cancel-text="Cerrar"
		ok-text="Enviar"
		@cancel="close"
	>
		<div class="row">
			<div class="col-12">
				<a-form-item
					:validate-status="validTo.state"
					has-feedback
				>
					<a-select
						v-model="to"
						mode="tags"
						class="w-100"
						:token-separators="[',', ';']"
						not-found-content=""
						placeholder="Destinatario"
					/>
				</a-form-item>

				<a-form-item
					:validate-status="validCC.state"
					has-feedback
					l
				>
					<a-select
						v-model="cc"
						mode="tags"
						class="w-100"
						placeholder="CC"
						not-found-content=""
					/>
				</a-form-item>

				<a-divider />

				<a-form-item
					class="d-flex align-items-center"
					label="Asunto"
					:label-col="{ span: 2 }"
					:wrapper-col="{ span: 22 }"
				>
					<a-input
						v-model="subject"
						:placeholder="defaultSubject"
					/>
				</a-form-item>

				<g-editor
					v-model="html"
					:mandatory="htmlMandatory"
					help-position="bottom"
				/>
			</div>
		</div>

		<template slot="footer">
			<a-button
				key="back"
				class="mr-2"
				@click="close"
			>
				Cerrar
			</a-button>
			<a-popconfirm
				title="Se enviará el email a los destinatarios ¿Estas seguro?"
				cancel-text="Cerrar"
				ok-text="Enviar"
				@confirm="() => send()"
			>
				<a-icon
					slot="icon"
					type="question-circle-o"
					class="text-warning"
				/>
				<a-button
					key="submit"
					type="primary"
					:loading="loading"
					:disabled="!valid"
				>
					Enviar
				</a-button>
			</a-popconfirm>
		</template>
	</a-modal>
</template>

<script>
import _ from 'lodash';

export default {
	props: {
		item: {
			type: Object,
			default: null
		},
		view: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			subject: 'Tu presupuesto esta listo',
			defaultSubject: 'Tu presupuesto esta listo',
			to: [],
			cc: [],
			loading: false,
			html: ''
		};
	},
	computed: {
		visible() {
			if (this.item !== null) return true;
			return false;
		},
		valid() {
			if (this.validTo.pass && this.validCC.pass) return true;
			return false;
		},
		validTo() {
			const result = {
				pass: false,
				state: 'error'
			};

			if (this.to.length > 0) {
				result.pass = true;
				result.state = 'success';
			}

			this.to.forEach((val) => {
				const valid = this.validEmail(val);
				if (!valid) {
					result.pass = false;
					result.state = 'error';
				}
			});

			return result;
		},
		validCC() {
			const result = {
				pass: true,
				state: ''
			};

			if (this.cc.length > 0) result.state = 'success';

			this.cc.forEach((val) => {
				const valid = this.validEmail(val);
				if (!valid) {
					result.pass = false;
					result.state = 'error';
				}
			});

			return result;
		},
		htmlMandatory() {
			if (this.item) {
				return `<center><a href="${this.item.PresupuestoPDF.Link}" style="background-color:${this.$colors.primary};border-radius:5px;color:#ffffff;display:inline-block;font-family:'Cabin', Helvetica, Arial, sans-serif;font-size:14px;font-weight:regular;line-height:45px;text-align:center;text-decoration:none;width:155px;-webkit-text-size-adjust:none;mso-hide:all;">Descargar</a></center><!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${this.item.PresupuestoPDF.Link}" style="height:45px;v-text-anchor:middle;width:155px;" arcsize="15%" strokecolor="#ffffff" fillcolor="${this.$colors.primary}"><w:anchorlock/><center style="color:#ffffff;font-family:Cabin, Helvetica, Arial, sans-serif;font-size:14px;font-weight:regular;">Descargar</center></v:roundrect><![endif]-->`;
			}

			return '';
		}
	},
	created() {
		const tlf = this.$gestios.$cache.config.EmpresaTelefono;

		if (tlf) {
			this.html = `<h3><b>Tu presupuesto esta listo</b></h3><p>Hola, te enviamos el presupuesto sobre los servicios solicitados. Recuerda que si tienes cualquier duda respecto a ella puedes contactarnos al teléfono ${tlf}.</p>`;
		} else {
			this.html = '<h3><b>Tu presupuesto esta listo</b></h3><p>Hola, te enviamos el presupuesto sobre los servicios solicitados.</p>';
		}
	},
	methods: {
		close() {
			this.to = [];
			this.cc = [];
			this.loading = false;
			this.subject = this.defaultSubject;
			this.html = '';

			this.$emit('close');
		},
		async send() {
			if (this.valid && !this.loading) {
				const f = _.cloneDeep(this.item);

				this.loading = true;

				const params = {
					email: this.to.join(','),
					cc: this.cc.join(','),
					subject: this.subject ? this.subject : this.defaultSubject,
					message: this.html + this.htmlMandatory,
					folder: 'Presupuestos'
				};

				const mailer = await this.$gestios.emails.send(params);

				if (mailer) {
					const edit = await this.$gestios.items('presupuestos').edit({ id: f._EntityId, params: { Email: mailer.data.ID } });

					if (edit.ok) {
						this.$message.success('El presupuesto se envió correctamente');
						this.close();
					} else {
						this.$message.warning('El mensaje se envió pero no se pudo asociar al presupuesto');
					}
				}

				this.loading = false;
			} else {
				this.message.error('Revisa que las direcciones especificadas de email son correctas');
			}
		},
		validEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		}
	}
};
</script>

<style lang="scss" module>
	// .mediumEditor{
	// 	background-color: var(--gray-1);
	// 	padding: 10px;
	// 	border: 1px dashed var(--gray-4);;
	// 	border-radius: 8px;
	// 	outline: none;

	// 	p:last-child{
	// 		margin-bottom: 0px;
	// 	}
	// }

	// .mediumEditor:focus{
	// 	background-color: transparent;
	// }
</style>
